import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FilePond, FilePondFile} from "filepond";

@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    standalone: false
})
export class FileUploadComponent implements OnInit {

  @ViewChild('myPond') myPond: FilePond;

  @Input('fileType') fileType: string
  @Output('onFileUpdate') onFileUpdate = new EventEmitter<FilePondFile[]>

  pondOptions = {};

  ngOnInit(): void {
    this.initPondOptions()
  }

  initPondOptions() {
    this.pondOptions = {
      class: 'filepond',
      name: 'filepond',
      dataMaxFileSize: "1MB",
      labelIdle: 'Clique aqui para adicionar uma imagem',
      allowReplace: 'true',
      allowProcess: 'false',
      acceptedFileTypes: this.fileType, //todo utilizar Tipos para abstrair a implementação
      labelFileTypeNotAllowed: 'Tipo de ficheiro não é válido.', // todo utilizar objecto de mensagem
      fileValidateTypeLabelExpectedTypes: '', //todo utilizar o tipo do ficheiro para produzir uma mensagem mais precisa
      maxFileSize: '1Mb', // todo passar como input.
      labelMaxFileSizeExceeded: 'Tamanho não é válido.', // todo utilizar objecto de mensagem
      labelMaxFileSize: 'Tamanho aceite {filesize}' // todo utilizar objecto de mensagem
    };
  }

  onUpdateFiles() {
    this.onFileUpdate.emit(this.myPond.getFiles())
  }
}
